import type { Layout as MediaSingleLayout } from '@atlaskit/adf-schema/rich-media-common';

export const wrappedLayouts: MediaSingleLayout[] = [
	'wrap-left',
	'wrap-right',
	'align-end',
	'align-start',
];
